import {useEffect} from "react";
import {useRouteError} from "react-router-dom";
import ErrorMessage from '../components/selfcare/ErrorMessage';
import * as Sentry from "@sentry/react";

export default function ErrorRoute() {
    const error: unknown = useRouteError();
    const customer_id = localStorage.getItem('current_customer');

    useEffect((): void => {
        Sentry.captureException(error);
    }, [customer_id, error]);

    return (
        <ErrorMessage />
    )
}
